import Glide from '@glidejs/glide';

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    setTimeout(() => {
      const gliders = document.querySelectorAll('.glide')

      gliders.forEach((glider) => {
        const slide = glider.querySelector('.glide__slide')

        const glideOptions = {
          type: 'carousel',
          bound: true,
          perView: 3,
          focusAt: 0,
          gap: glider.clientWidth / 100 * 3.975,
          slideWidth: glider.clientWidth / 100 * 30.5810397554,
          peek: 0,
          breakpoints: {
            1023: {
              perView: 1,
              peek: 42,
              slideWidth: slide.clientWidth,
              gap: 15,
            },
          },
        };

        const carousel = new Glide(glider, glideOptions)

        carousel.on('mount.after', () => {
          glider.classList.add('show');
        })

        carousel.mount()
      })

    }, 1)
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js